import { render, staticRenderFns } from "./alipayWechat.vue?vue&type=template&id=4bedf841&scoped=true&"
import script from "./alipayWechat.vue?vue&type=script&lang=js&"
export * from "./alipayWechat.vue?vue&type=script&lang=js&"
import style0 from "./alipayWechat.vue?vue&type=style&index=0&id=4bedf841&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bedf841",
  null
  
)

export default component.exports